var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0002 43.0002C46.9512 43.0002 45.195 44.2344 44.4216 46.0002H35.6328C34.8066 43.6716 32.6094 42 30 42C27.3906 42 25.1952 43.6716 24.3672 46.0002H15.5784C14.805 44.2344 13.0488 43.0002 10.9998 43.0002C8.238 43.0002 6 45.2382 6 48C6 50.7618 8.238 52.9998 10.9998 52.9998C13.0506 52.9998 14.8068 51.762 15.5784 49.9998H24.3672C25.1934 52.3242 27.3906 54 30 54C32.6094 54 34.8066 52.3242 35.6328 49.9998H44.4216C45.1932 51.762 46.9494 52.9998 49.0002 52.9998C51.762 52.9998 54 50.7618 54 48C54 45.2382 51.762 43.0002 49.0002 43.0002ZM30 49.9998C28.8942 49.9998 28.0002 49.1058 28.0002 48C28.0002 46.8942 28.8942 46.0002 30 46.0002C31.1058 46.0002 31.9998 46.8942 31.9998 48C31.9998 49.1058 31.1058 49.9998 30 49.9998Z",
    fill: "#1A5298"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6C22.2714 6 16.0002 12.2652 16.0002 19.9998C16.0002 23.8632 17.5662 27.363 20.1018 29.8986L30 39L39.9006 29.8944C42.4356 27.363 44.0022 23.8632 43.9998 19.9962C43.9998 12.2694 37.7328 6 30 6ZM30 25.9998C26.6874 25.9998 24 23.3124 24 19.9998C24 16.6872 26.6874 13.9998 30 13.9998C33.3144 13.9998 36 16.6872 36 19.9998C36 23.3124 33.3144 25.9998 30 25.9998Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.c4fb9443e95610b2c290ba2018deb997.svg";
export { ForwardRef as ReactComponent };